import './main.less';
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { reduxForm, getFormValues, Field, FieldArray } from 'redux-form';
import { Link } from 'react-router';
import { connect } from 'react-redux';

import InputField from '../../../shared/form-elements/input';
import CheckboxField from '../../../shared/form-elements/checkbox';
import SelectField from '../../../shared/form-elements/select/field';
import AdditionalManagers from './additional-managers';

const isRocket = process.env.CPA_ENV === 'rocket';

const propTypes = {
	intl: PropTypes.func,
	formData: PropTypes.object,
	locationsLookup: PropTypes.func,
	citiesLookup: PropTypes.func,
	managersLookup: PropTypes.func,
	timezonesLookup: PropTypes.func,
	submitForm: PropTypes.func,
	handleSubmit: PropTypes.func
};

const isEverad = process.env.CPA_ENV === 'everad';

const Form = ({
	intl,
	data,
	can,
	isNewLeadSource,
	updatePossibleRegions,
	addNewLeadSource,
	formValues,
	formData,
	locationsLookup,
	leadSourcesLookup,
	loadRegionsLookup,
	switchHungarianCampaigns,
	citiesLookup,
	managersLookup,
	timezonesLookup,
	handleSubmit,
	submitForm,
	copyConfirmationLink,
	sendConfirmationEmail
}) => (
	<form className="ui-form affiliate-main__form" onSubmit={handleSubmit(data => submitForm(data))}>
		<div className="ui-form__element">
			<Field
				name="email"
				placeholder={ intl('Email') }
				component={InputField} />
		</div>

		<div className="ui-form__element">
			<Field
				name="nickname"
				placeholder={ intl('Nickname') }
				component={InputField} />
		</div>

		<div className="ui-form__element">
			<Field
				name="phone"
				placeholder={ intl('Phone') }
				component={InputField} />
		</div>

		<div className="ui-form__element">
			<Field
				name="skype"
				placeholder={ intl('Skype') }
				component={InputField} />
		</div>

		<div className="ui-form__element">
			<Field
				name="whatsapp"
				placeholder={ intl('Whatsapp') }
				component={InputField} />
		</div>

		<div className="ui-form__element">
			<Field
				name="telegram"
				placeholder={ intl('Telegram') }
				component={InputField} />
		</div>

		<div className={cn('ui-form__element', isRocket && `account_status ${formValues && formValues.level[0].value}`)}>
			<Field
				name="level"
				searchable={false}
				placeholder={intl(!isRocket ? 'Level' : 'Account status')}
				multi={false}
				component={SelectField}
				options={formData.options.levels}  />
		</div>

		<div className="ui-form__element" style={{ display: 'flex' }}>
			<div style={{ flex: 1 }}>
				<Field
					name="status"
					searchable={false}
					placeholder={intl(!isRocket ? 'Status' : 'Confirmation status')}
					multi={false}
					component={SelectField}
					disabled={isRocket}
					options={formData.options.statuses}  />
			</div>

			{isRocket && data.status === 'not_confirmed' && (
				<button
					className="ui-btn ui-btn-cancel"
					style={{ marginTop: 'auto', marginLeft: 20 }}
					type="button"
					onClick={() => copyConfirmationLink(data.id)}
				>
					{intl('Copy confirmation link')}
				</button>
			)}

			{isRocket && data.status === 'not_confirmed' && (
				<button
					className="ui-btn ui-btn-cancel"
					style={{ marginTop: 'auto', marginLeft: 20 }}
					type="button"
					onClick={() => sendConfirmationEmail(data.email)}
				>
					{intl('Send confirmation email')}
				</button>
			)}
		</div>

		<div className="ui-form__element">
			<Field
				name="internal_rank"
				searchable={false}
				placeholder={intl('Internal rank')}
				clearable={false}
				multi={false}
				component={SelectField}
				options={formData.options.internalRanks}  />
		</div>

		<div className="ui-form__element">
			<Field
				name="language"
				searchable={false}
				placeholder={ intl('Language') }
				multi={false}
				component={SelectField}
				options={formData.options.languages}  />
		</div>

		<div className="ui-form__element">
			<Field
				name="timezone"
				placeholder={ intl('Timezone') }
				multi={false}
				component={SelectField}
				options={timezonesLookup}  />
		</div>

		<div className="ui-form__element">
			<Field
				name="location_id"
				placeholder={ intl('Location') }
				multi={false}
				component={SelectField}
				options={locationsLookup}  />
		</div>

		<div className="ui-form__element">
			<Field
				name="city_id"
				placeholder={ intl('City') }
				multi={false}
				component={SelectField}
				options={citiesLookup}  />
		</div>

		<div className="ui-form__element">
			<Field
				name="manager_id"
				placeholder={ intl('Manager') }
				multi={false}
				component={SelectField}
				options={managersLookup}  />
		</div>
		{
			isEverad &&
			<div className="ui-form__element min-width-300">
				<Field
					name="manager_regions"
					placeholder={intl('Select manager regions')}
					component={SelectField}
					multi={true}
					showLabel={false}
					options={loadRegionsLookup}
				/>
			</div>
		}

		<div className="ui-form__element">
			{
				isEverad &&
				<FieldArray
					name="additional_managers"
					placeholder={intl('Select region') }
					multi={false}
					intl={intl}
					formValues={formValues}
					updatePossibleRegions={updatePossibleRegions}
					loadRegionsLookup={loadRegionsLookup}
					managersLookup={managersLookup}
					component={AdditionalManagers}
				/>
			}
		</div>

		<div className="ui-form__element">
			<Field
				name="tags"
				placeholder={ intl('Tags') }
				format={val => val && val.join(', ')}
				normalize={val => val && val.split(', ')}
				component={InputField} />
		</div>

		<div className="ui-form__element">
			<Field
				name="whitelisted_ips"
				placeholder={ intl('Whitelist ips') }
				format={val => val && val.join(', ')}
				normalize={val => val && val.split(', ')}
				component={InputField} />
		</div>
		{
			!isRocket &&
			<div className="ui-form__element lead_sources">
				<Field
					name="lead_source_names"
					placeholder={ intl('Lead sources') }
					multi={true}
					component={SelectField}
					options={leadSourcesLookup}  />
				{
					can('add_lead_source') &&
					<button
						type="button"
						className={`ui-btn ui-btn-primary ${isNewLeadSource ? '' : 'ui-btn-cancel'}`}
						disabled={!isNewLeadSource}
						onClick={addNewLeadSource}
					>
						{intl('+')}
					</button>
				}
			</div>
		}

		<div className="ui-form__element">
			<Field
				name="birthday"
				placeholder={ intl(
					'Birthday(s) %s separated by "," if few. MM-DD if year is undefined.', 'YYYY-MM-DD'
				) }
				component={InputField} />
		</div>

		<div className="ui-form__element">
			<Field
				name="ref_id"
				placeholder={
					intl('Affiliate ID in another CPA') + ' (' +
					intl('when specifying id - affiliate will participate in contest of another CPA; points will be awarded !!!')
					+ ')'
				}
				component={InputField} />
		</div>

		<div className="ui-form__element">
			<Field
				name="is_master"
				placeholder={ intl('Is master') }
				component={CheckboxField} />
		</div>

		{ process.env.CPA_ENV === 'everad' &&
			<div className="ui-form__element">
				<Field
					name="is_suspicious"
					placeholder={ intl('Is duplicate') }
					component={CheckboxField} />
			</div>
		}

		{ process.env.CPA_ENV === 'everad' &&
			<div className="ui-form__element">
				<Field
					name="is_possible_fraud"
					placeholder={ intl('Is suspicious') }
					component={CheckboxField} />
			</div>
		}

		{!isRocket && (
			<div className="ui-form__element">
				<Field
					name="allow_dangerous_snippets"
					placeholder={ intl('Allow dangerous landing snippets') }
					component={CheckboxField} />
			</div>
		)}

		{!isRocket && (
			<div className="ui-form__element">
				<Field
					name="is_need_birthday_notification"
					placeholder={ intl('Notify about birthday?') }
					component={CheckboxField} />
			</div>
		)}

		{!isRocket && (
			<div className="ui-form__element">
				<Field
					name="is_pseudotrash_enabled"
					placeholder={ intl('Is pseudotrash enabled') }
					component={CheckboxField}
					disabled={true}
				/>
			</div>
		)}

		<div className="ui-form__element">
			<Field
				name="is_staff"
				placeholder={ intl('Don`t deactivate') }
				component={CheckboxField}
			/>
		</div>

		<div className="ui-form__element">
			<Field
				name="is_top"
				placeholder={ intl('Is Top') }
				component={CheckboxField}
			/>
		</div>

		<div className="ui-form__element display-flex">
			<button className="ui-btn ui-btn-primary">{ intl('Edit') }</button>
			<Link to="affiliates/" className="margin-0-15">
				<button type="button" className="ui-btn ui-btn-cancel">
					{intl('Cancel')}
				</button>
			</Link>
			{
				window.globalConfig &&
				window.globalConfig.showChangeCampaignCurrencyButton &&
				<div>
					<span className="display-inline-block padding-top-30 margin-0-15">
						{intl('Change Hungarian campaigns currency to:')}
					</span>
					<button
						type="button" className="ui-btn ui-btn-primary"
						onClick={switchHungarianCampaigns.bind(null, 'usd')}
					>
						{intl('usd')}
					</button>
					<button
						type="button" className="ui-btn ui-btn-primary"
						onClick={switchHungarianCampaigns.bind(null, 'eur')}
					>
						{intl('eur')}
					</button>
				</div>
			}
		</div>
	</form>
);

Form.propTypes = propTypes;
export default connect((state) => ({
	formValues: getFormValues('affiliateMainForm')(state)
}))(reduxForm({
	form: 'affiliateMainForm'
})(Form));



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/affiliates/components/form/main.js